import "./LoadingSpinner.css";

/**
 * LoadingSpinner
 *
 * Props:
 *   overlay  {boolean}  – if true, renders as a fixed full-screen overlay
 *                         (use for form submits: login, signup, payment verify…)
 *   message  {string}   – primary text, e.g. "Logging in"
 *   sub      {string}   – secondary hint, e.g. "Please wait…"
 */
function LoadingSpinner({ overlay = false, message = "Loading", sub = "" }) {
  const wrapClass = overlay ? "loader-overlay" : "loader-page";

  return (
    <div className={wrapClass} role="status" aria-live="polite">
      {/* Ring */}
      <div className="loader-ring-wrap">
        <div className="loader-ring" />
        <div className="loader-dot" />
      </div>

      {/* Text */}
      <p className="loader-title">
        <span className="loader-dots">{message}</span>
      </p>

      {sub && <p className="loader-sub">{sub}</p>}
    </div>
  );
}

export default LoadingSpinner;
